/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useState, useEffect } from 'react';
export const useDevices = (forceUpdate) => {
    const [devices, setDevices] = useState([]);
    useEffect(() => {
        var _a;
        const getDevices = () => {
            var _a;
            (_a = window.navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.enumerateDevices().then((devices) => {
                setDevices(devices);
            });
        };
        (_a = window.navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.addEventListener('devicechange', getDevices);
        getDevices();
        return () => {
            var _a;
            (_a = window.navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.removeEventListener('devicechange', getDevices);
        };
    }, [forceUpdate]);
    return {
        audioInputDevices: devices.filter((device) => device.kind === 'audioinput'),
        videoInputDevices: devices.filter((device) => device.kind === 'videoinput'),
        audioOutputDevices: devices.filter((device) => device.kind === 'audiooutput'),
        hasAudioInputDevices: !!devices.filter((device) => device.kind === 'audioinput').length,
        hasVideoInputDevices: !!devices.filter((device) => device.kind === 'videoinput').length
    };
};
//# sourceMappingURL=useDevices.js.map